import isObject from 'lodash/isObject'
import isArray from 'lodash/isArray'
import { getAppData } from '@/utils'
import actions from './actions'
import state from './state'

export default {
	namespaced : true,
	state,
	getters    : {
		hasMailPoet    : state => null !== state.config.hasMailPoet ? state.config.hasMailPoet : getAppData('hasMailPoet'),
		mailPoetLists  : state => state.config.mailPoetLists.length ? state.config.mailPoetLists : getAppData('mailPoetLists'),
		mailPoetFields : state => state.config.mailPoetFields.length ? state.config.mailPoetFields : getAppData('mailPoetFields'),
		wooKey         : state => state.wooKey.id ? state.wooKey : getAppData('wooKey', state.wooKey),
		isWooActive    : state => null !== state.config.isWooActive ? state.config.isWooActive : getAppData('isWooActive'),
		isWooConnected : state => null !== state.config.isWooConnected ? state.config.isWooConnected : getAppData('isWooConnected'),
		isEddActive    : state => null !== state.config.isEddActive ? state.config.isEddActive : getAppData('isEddActive'),
		isEddConnected : state => null !== state.config.isEddConnected ? state.config.isEddConnected : getAppData('isEddConnected'),
		eddVersion     : state => null !== state.config.eddVersion ? state.config.eddVersion : getAppData('eddVersion'),
		eddKey         : state => null !== state.eddKey ? state.eddKey : getAppData('eddKey'),
		eddToken       : state => null !== state.eddToken ? state.eddToken : getAppData('eddToken'),
		hasError       : state => !!state.error,
	},
	mutations : {
		setWooKey (state, payload) {
			state.wooKey = payload
		},
		setError (state, payload) {
			state.error = payload
		},
		setWpCampaigns (state, payload) {
			if (isArray(payload)) {
				state.campaigns = payload
			}
		},
		setWpTaxonomies (state, payload) {
			if (isObject(payload)) {
				state.taxonomies = payload
			}
		},
		setWooConnected (state, payload) {
			state.config.isWooConnected = payload
		},
		setWpConfig (state, payload) {
			if (isObject(payload)) {
				state.config = payload
			}
		},
		setWpPosts (state, payload) {
			if (isArray(payload)) {
				state.posts = payload
			}
		},
		setWpPostTypes (state, payload) {
			if (isArray(payload)) {
				state.postTypes = payload
			}
		},
		setEddConnected (state, payload) {
			state.config.isEddConnected = payload
		},
		setEddVersion (state, payload) {
			this._vm.$set(state, 'config', {
				...state.config,
				eddVersion : payload,
			})
		},
		setEddKey (state, payload) {
			state.eddKey = payload
		},
		setEddToken (state, payload) {
			state.eddToken = payload
		},
	},
	actions,
}
